import { cn } from '@/lib/utils';

export const EXTERNAL_SOURCE_SECTION = 'flex flex-col items-start gap-4 space-y-0 self-stretch';

export const EXTERNAL_SOURCE_FIELD =
  'flex flex-col items-start gap-2 space-y-0 self-stretch [&>label]:mb-0 [&>label]:text-foreground';

export const EXTERNAL_SOURCE_CATEGORIES = cn(EXTERNAL_SOURCE_SECTION, 'pb-2');

export const EXTERNAL_SOURCE_FOOTER =
  '-mx-6 flex-1 flex-row items-end justify-end gap-2 self-stretch p-6';
